import Vue from 'vue';
import Vuex from 'vuex';
import createVuexAlong from 'vuex-along';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tagList: [],
    tagActiveIndex: 0,
    token: '',
    personInfo: {}
  },
  // getters:{
  //   getTag(state) {
  //     return state.tagList;
  //   },
  //   getTagActiveIndex(state){
  //     return state.tagActiveIndex;
  //   }
  // },
  mutations: {
    setToken(state, token){
      state.token = token;
    },
    setTag(state, tag){
      let index = -1;
      for(let i=0; i<state.tagList.length; i++){
        if(tag.path.path === state.tagList[i].path.path){
          index = i;
        }
      }
      if(index === -1){ //标签列表没有对应项
        // state.tagList.push(tag);
        let activeIndex = state.tagList.length === 0 ? 0 : state.tagActiveIndex + 1;
        state.tagList.splice(state.tagActiveIndex+1, 0 ,tag);
        this.commit('setTagActiveIndex', activeIndex);
        // this.commit('setTagActiveIndex', state.tagList.length - 1);
      }else{//标签列表有对应项
        this.commit('setTagActiveIndex', index);
      }
    },
    delTag(state, index){
      state.tagList.splice(index, 1);
    },
    setTagActiveIndex(state, index){
      state.tagActiveIndex = index;
    },
    resetTag(state){
      state.tagList = [];
      this.commit('setTagActiveIndex', 0);
    },
    setPersonInfo(state, info){
      state.personInfo = info;
    }
  },
  actions: {
  },
  modules: {

  },
  //相当于vue的computed计算属性
  plugins: [
    createVuexAlong({
      // 设置保存的集合名字，避免同站点下的多项目数据冲突
      name: 'vuex-along',
      local: {
        list: ['']
        // 过滤模块 ma 数据， 将其他的存入 localStorage
      },
      session: {
        // 过滤模块 ma 数据
        list: ['token', 'tagList', 'tagActiveIndex']
      }
    })
  ]
})
